import { createContext, useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const BRAND = 'Ct'

const TITLES = {
  '/': BRAND,
  '/login': 'Log in',
  '/signup': 'Sign up',
  '/onboarding': 'Onboarding',
  '/home': 'Home',
  '/projects': 'Projects',
  '/code': 'Code',
  '/searchrooms': 'Searchrooms',
  '/global-ai-search': 'Global AI Search',
  '/global-text-search': 'Global Text Search',
  '/notebooks': 'Notes',
  '/guides': 'Guides',
  '/topics': 'Topics',
  '/chat': 'Chat',
  '/network': 'Network',
}

const PageTitleContext = createContext({ setCrumb: () => {} })

function titleFor(pathname, crumb) {
  const page = TITLES[pathname]
  if (page === BRAND) return BRAND
  const bits = []
  bits.push(page || 'Not found')
  if (crumb) bits.push(crumb)
  return bits.join(' | ')
}

function cleanCrumb(value) {
  const text = typeof value === 'string' ? value.trim() : ''
  if (!text || text === 'New window' || text === 'Loading…') return ''
  return text
}

// Pages with an active window (Code, Searchrooms, …) report its label here so
// the tab reads "Code | ACI 318-19". Empty windows add no crumb.
export function usePageTitle(crumb) {
  const { setCrumb } = useContext(PageTitleContext)
  const next = cleanCrumb(crumb)
  useEffect(() => {
    setCrumb(next)
    return () => setCrumb('')
  }, [next, setCrumb])
}

function DocumentTitle({ children }) {
  const { pathname } = useLocation()
  const [crumb, setCrumb] = useState('')

  useEffect(() => {
    document.title = titleFor(pathname, crumb)
  }, [pathname, crumb])

  return <PageTitleContext.Provider value={{ setCrumb }}>{children}</PageTitleContext.Provider>
}

export default DocumentTitle
